import { useState, useEffect } from 'react';
import api from '../services/api';
import Button from '../components/Button';
import Input from '../components/Input';
import Table, { Column } from '../components/Table';

export default function Policies() {
  const [policies, setPolicies] = useState<any[]>([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ policyName: '', description: '', version: '1.0', effectiveFrom: '' });
  const [file, setFile] = useState<File | null>(null);

  const fetchPolicies = async () => {
    const res = await api.get('/hr/policies');
    setPolicies(res.data.policies || []);
  };

  useEffect(() => {
    fetchPolicies();
  }, []);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    const data = new FormData();
    Object.entries(form).forEach(([k, v]) => data.append(k, v));
    if (file) data.append('file', file);
    try {
      await api.post('/hr/policies', data, { headers: { 'Content-Type': 'multipart/form-data' } });
      setForm({ policyName: '', description: '', version: '1.0', effectiveFrom: '' });
      setFile(null);
      setShowForm(false);
      fetchPolicies();
    } catch (error: any) {
      alert(error.response?.data?.message || 'Failed to upload policy');
    }
  };

  const deactivate = async (id: string) => {
    await api.delete(`/hr/policies/${id}`);
    fetchPolicies();
  };

  const columns: Column<any>[] = [
    { key: 'policy_name', header: 'Name' },
    { key: 'policy_version', header: 'Version' },
    { key: 'effective_from', header: 'Effective From', render: (r) => (r.effective_from ? new Date(r.effective_from).toLocaleDateString() : '-') },
    { key: 'is_active', header: 'Active', render: (r) => (r.is_active ? 'Yes' : 'No') },
    {
      key: 'actions',
      header: '',
      render: (r) => (
        <div className="flex gap-3">
          {r.policy_file_url && (
            <a className="text-blue-600 hover:underline text-sm" href={r.policy_file_url} target="_blank" rel="noreferrer">
              Download
            </a>
          )}
          {r.is_active && (
            <button className="text-red-600 hover:underline text-sm" onClick={() => deactivate(r.id)}>
              Deactivate
            </button>
          )}
        </div>
      ),
    },
  ];

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Company Policies</h1>
        <Button onClick={() => setShowForm(!showForm)}>{showForm ? 'Cancel' : 'Upload Policy'}</Button>
      </div>

      {showForm && (
        <form onSubmit={submit} className="bg-white rounded-lg shadow p-6 space-y-4 mb-6">
          <Input label="Policy Name" value={form.policyName} onChange={(e) => setForm({ ...form, policyName: e.target.value })} required />
          <textarea className="w-full border rounded-lg px-3 py-2" placeholder="Description" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} />
          <div className="grid grid-cols-2 gap-4">
            <Input label="Version" value={form.version} onChange={(e) => setForm({ ...form, version: e.target.value })} />
            <Input label="Effective From" type="date" value={form.effectiveFrom} onChange={(e) => setForm({ ...form, effectiveFrom: e.target.value })} />
          </div>
          <input type="file" onChange={(e) => setFile(e.target.files?.[0] || null)} />
          <Button type="submit">Upload</Button>
        </form>
      )}

      <Table columns={columns} rows={policies} emptyMessage="No policies uploaded" />
    </div>
  );
}
